export default class StripeCard {
  id;
  brand;
  expirationMonth;
  expirationYear;
  last4;
  isDefault;

  constructor(id, brand, expirationMonth, expirationYear, last4, isDefault) {
    this.id = id;
    this.brand = brand;
    this.expirationMonth = expirationMonth;
    this.expirationYear = expirationYear;
    this.last4 = last4;
    this.isDefault = isDefault;
  }

  static firebaseConverter = {
    fromFirestore(snapshot, options) {
      let id = snapshot.id;
      const data = { id, ...snapshot.data(options) };

      return new StripeCard(
        data.id,
        data.brand,
        data.expirationMonth,
        data.expirationYear,
        data.last4,
        data.isDefault
      );
    },

    toFirestore(stripeCard) {
      let {
        id,
        brand,
        expirationMonth,
        expirationYear,
        last4,
        isDefault
      } = stripeCard;
      return {
        id,
        brand,
        expirationMonth,
        expirationYear,
        last4,
        isDefault
      };
    }
  };
}
